<template>
  <v-btn
      :icon="true"
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="warning"
      @click="init()"
  >
    <v-icon>
      mdi-pencil
    </v-icon>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Upraviť užívateľa

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p>
            Pre upravenie užívateľa je potrebné vyplniť všetky povinné polia.
          </p>

          <v-text-field
              v-model="UserForm.name"
              :error-messages="errors.name"
              :outlined="true"
              :dense="true"
              label="Meno"
          />

          <v-text-field
              v-model="UserForm.username"
              :error-messages="errors.username"
              :outlined="true"
              :dense="true"
              label="Užívateľské meno"
          />

          <v-text-field
              v-model="UserForm.email"
              :error-messages="errors.email"
              :outlined="true"
              :dense="true"
              label="E-mail"
          />

          <v-text-field
              v-model="UserForm.phone"
              :error-messages="errors.phone"
              :outlined="true"
              :dense="true"
              label="Telefón"
              :persistent-hint="true"
              hint="V prípade, že nevieš tak: xxxxxxxxxxxx"
          />

          <v-select
              v-model="UserForm.type"
              :error-messages="errors.type"
              :outlined="true"
              :dense="true"
              label="Typ"
              :items="$store.getters['register/getUserType']"
          />

          <v-btn
              :rounded="true"
              :outlined="true"
              :loading="loading"
              :disabled="loading"
              color="warning"
              @click="submit()"
          >
            <v-icon>
              mdi-pencil
            </v-icon>

            Upraviť
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Users from '@/services/users'

  export default {
    name: 'Update',
    props: [
      'id'
    ],
    data() {
      return {
        loading: false,
        dialog: false,
        User: {},
        UserForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = false

        this.loading = true

        Users
          .read({
            id: this.id
          })
          .then((response) => {
            this.dialog = true

            this.User - response.data.data.User

            this.UserForm = {
              name: response.data.data.User.name,
              username: response.data.data.User.username,
              email: response.data.data.User.email,
              phone: response.data.data.User.phone,
              type: response.data.data.User.type
            }

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.dialog = true

            this.loading = false
          })
      },
      submit() {
        this.loading = true

        Users
          .update({
            id: this.id,
            data: this.UserForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
